import * as cssUtils from '@design-system/component-library/src/utils/css.js';

type CssUtilsModule = typeof cssUtils & {
  default?: Partial<typeof cssUtils>;
};

const dsCssUtils = cssUtils as CssUtilsModule;

const getBreakpoint = (name: 'BREAKPOINT_S' | 'BREAKPOINT_L'): number => {
  const value = dsCssUtils[name] ?? dsCssUtils.default?.[name];
  if (value === undefined) {
    throw new Error(`Missing ${name} from component-library css utils`);
  }
  return value;
};

export const BREAKPOINT_S = getBreakpoint('BREAKPOINT_S');
export const BREAKPOINT_L = getBreakpoint('BREAKPOINT_L');
